import type {ProgressProps as ChakraProgressProps} from '@chakra-ui/react';
import {Progress as BaseProgress} from '@chakra-ui/react';

export type ProgressProps = ChakraProgressProps;

export const Progress = (props: ProgressProps) => {
  const {...rest} = props;
  return <BaseProgress {...rest} />;
};
